import { apiPost } from "./apiClient";

// Log Monitor lives on the app-gateway under /app/v1/log-monitor.
// Routed through the shared gateway client (apiClient) exactly like every other
// beadmin service: POST with an AES-encrypted body and an AES-encrypted response
// (apiPost defaults: encrypt:true + decrypt:true), sending the same headers
// (x-access-token + x-api-key + Access-Control-* + Content-Type via
// getBeAdminHeaderConfig). Base host resolves from environment.js.
const LOG_MONITOR_BASE = "/app/v1/beadmin";

// POST /app/v1/log-monitor/logs -> { success, meta, summary, logs[] }
export const fetchLogs = (params, signal) =>
  apiPost(`${LOG_MONITOR_BASE}/logs`, params, { signal });

// POST /app/v1/log-monitor/logs/summary -> { success, meta, summary }
export const fetchLogsSummary = (params, signal) =>
  apiPost(`${LOG_MONITOR_BASE}/logs/summary`, params, { signal });
